module.exports = __webpack_public_path__ + "img/engraving-1.ee8ae66.png";